import React from "react"
import Content from "../../particles/Content"
import SubHeading from "../../atoms/SubHeading/SubHeading"
import StyledRowImage from "./RowImage.style"
import BackgroundImage from "gatsby-background-image"
import PrimaryButton from "../../atoms/Buttons/PrimaryButton/PrimaryButton"
import { GatsbyImage } from "gatsby-plugin-image";
import { convertToBgImage } from "gbimage-bridge";

const RowImage = ({
  RowImageBlock,
  children
}) => {
  const {
    rowImageTitle,
    rowImageText,
    rowImageField,
    imagePlacement,
    rowImageLink,
    style,
    small

  } = RowImageBlock
  const bgImage = convertToBgImage(rowImageField.localFile.childImageSharp.gatsbyImageData);
  return (
    <StyledRowImage
      imagePlacement={imagePlacement || undefined}
      style={style || undefined}
      backgroundColor="#ffffff"
    >
      <Content>
        <section>
          {rowImageTitle ? <SubHeading title={rowImageTitle} /> : null}
          {rowImageText ? (
            <div dangerouslySetInnerHTML={{ __html: rowImageText }} />
          ) : (
            <div className="children">{children}</div>
          )}

          {rowImageLink && rowImageLink.url ? (
            <PrimaryButton url={rowImageLink.url}>
              {rowImageLink.title}
            </PrimaryButton>
          ) : null}
        </section>
        {small ? (
          <section style={{ alignSelf: `center` }}>
            <GatsbyImage alt={rowImageField.altText} image={rowImageField.localFile.childImageSharp.gatsbyImageData} />
          </section>
        ) : (
          <BackgroundImage
            Tag="section"
            {...bgImage}
            className="hide-mobile"
          />
        )
      }
      </Content>
    </StyledRowImage>
  );
}

export default RowImage
